'use strict';

var helper = require('../helper');

module.exports = {
    pushHeaderClickInteractionFor (item) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '4',
            'eventname': 'header',
            'menu_items': item
        };

        helper.log('Pushing header click impression for ' + item + '!', true);
        helper.push(pushObject);
    },

    pushSearchInteraction (searchTerm) {
        if (!searchTerm) {
            return;
        }
        
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '11',
            'eventname': 'search',
            'type': 'type_in',
            'search_term': searchTerm
        };

        helper.log('Pushing search interaction for ' + searchTerm + '!', true);
        helper.push(pushObject);
    },

    // 6.15 SEARCH - LIVE SUGGESTION RESULTS
    pushSearchLiveSuggestionResults (section, word) {
        if (!section && !word) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '67',
            'eventname': 'search',
            'type': 'tips_clicked',
            'label': section,
            'search_term': word
        };

        helper.log('Pushing footer link click for ' + section + ', ' + word + '!', true);
        helper.push(pushObject);
    },

    // 6.16 SEARCH - CLICK TO CLOSE THE SEARCH BAR
    pushSearchOnCloseBtn () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '68',
            'eventname': 'search',
            'type': 'close_the_search'
        };
        helper.log('Pushing close btn on search', true);
        helper.push(pushObject);
    },

    // Menu
    pushMenuItemClickInteractionFor (item, topCategory, position) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '5',
            'eventname': 'menu',
            'position': position,
            'category': topCategory,
            'menu_items': item,
        };

        helper.log('Pushing menu click impression for ' + item + '!', true);
        helper.push(pushObject);
    },

    // 6.78 Unsubscribe from SMS
    pushUnsubscribeSmsForm () {
        helper.log('Unsubscribing from SMS', true);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '84',
            'eventname': 'sms_unsubscribe'
        };
        helper.push(pushObject);
    },

    pushMenuContentClickInteraction (item) {
        if (!item) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '7',
            'eventname': 'out_menu',
            'menu_items': item
        };

        helper.log('Pushing menu content link click impression for ' + item + '!', true);
        helper.push(pushObject);
    },

    pushOutOfMenuClickInteraction (voice) {
        if (!voice) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '72',
            'eventname': 'out_menu',
            'menu_items': voice
        };

        helper.log('Pushing out of menu click impression for ' + voice + '!', true);
        helper.push(pushObject);
    },

    // Search Filters
    pushSearchFilterSelectInteraction (filterCategoryType, category, selection) {
        if (!category && !selection) {
            return;
        }
        category = helper.formatString(category);
        selection = helper.formatString(selection);

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '12',
            'eventname': 'listing_filter',
            'action': 'apply',
            'category': filterCategoryType,
            'area': category,
            'text': selection
        };

        helper.log('Pushing search filter impression for \'' + category + '\', \'' + selection + '\'!', true);
        helper.push(pushObject);
    },

    pushSearchSortInteraction (orderType) {
        if (!orderType) {
            return;
        }

        orderType = helper.formatString(orderType);

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '13',
            'eventname': 'listing_sort_by',
            'type': orderType
        };

        helper.log('Pushing sort listing impression for ' + orderType + '!', true);
        helper.push(pushObject);
    },

    // Contact Us
    pushContactUsInteraction (requestType) {
        if (!requestType) {
            return;
        } else {
            let request = requestType.split(' ').join('_').toLowerCase();
            requestType = request.split('-').join('');
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '19',
            'eventname': 'contact_us',
            'text': requestType
        };

        helper.log('Pushing contact us impression for ' + requestType + '!', true);
        helper.push(pushObject);
    },

    // Social icons footer
    pushSocialClickInteractionFooter (social) {
        if (!social) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '22',
            'eventname': 'social',
            'action': 'follow',
            'type': social
        };

        helper.log('Pushing social footer click impression for ' + social + '!', true);
        helper.push(pushObject);
    },

    pushFooterLinkClickInteraction (type, name) {
        if (!name || !type) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '6',
            'eventname': 'footer',
            'menu_items': name,
            'type': type
        };

        helper.log('Pushing footer link click for ' + type + ', ' + name + '!', true);
        helper.push(pushObject);
    },

    giftcardCheckBalance (data) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '32',
            'eventname': 'gift_card',
            'action': 'check',
            'text': data.gcType.toLowerCase(),
            'coupon': data.gcCode
        };

        helper.log('Pushing giftcard check balance ' + data.gcType + '!', true);
        helper.push(pushObject);
    },

    giftcardApply (data) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '31',
            'eventname': 'gift_card',
            'action': 'apply',
            'text': data.gcType
        };

        helper.log('Pushing giftcard check balance ' + data.gcType + '!', true);
        helper.push(pushObject);
    },

    giftcardRemove (data) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '31',
            'eventname': 'gift_card',
            'action': 'remove',
            'text': data.gcType
        };

        helper.log('Pushing giftcard check balance ' + data.gcType + '!', true);
        helper.push(pushObject);
    },

    pushRefinementsClickInteraction (category, nameClicked) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '50',
            'eventname': 'listing_icon',
            'text': category + '_' + nameClicked
        };

        helper.log('Pushing refinement click for ' + nameClicked + '!', true);
        helper.push(pushObject);
    },

    pushChangeImageInteraction (skuClicked) {
        skuClicked = helper.getFormatSku(skuClicked);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '46',
            'eventname': 'product',
            'action': 'image_swipe',
            'product_id': skuClicked
        };
        helper.push(pushObject);
    },

    pushfaqInteraction (labelClicked) {
        if (!labelClicked) {
            return;
        }
        labelClicked = helper.formatString(labelClicked);
        labelClicked = labelClicked.replace(/[|&;$%@"<>()+,!?]/g, '');
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '56',
            'eventname': 'faq',
            'type': 'shopping_bag',
            'txt': labelClicked
        };
        helper.push(pushObject);
    },

    pushContinueShoppingInteraction () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '57',
            'eventname': 'start_the_shopping'
        };
        helper.push(pushObject);
    },

    pushNotifyMeSoldOutSize (productName, size, sku) {
        if (!productName || !size || !sku) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '47',
            'eventname': 'product',
            'action': 'notify_me',
            'text': size,
            'product_id': sku
        };

        helper.log('Pushing notify me sold out size ' + productName + ', ' + size + ', ' + sku + '!', true);
        helper.push(pushObject);
    },

    pushCancelSoldOutSize (callToAction, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '58',
            'eventCategory': 'product',
            'eventAction': 'size_out_of_stock',
            'eventLabel': callToAction,
            'dimension61': sku
        };

        helper.log('Pushing cancel sold out size notification ' + callToAction + ', ' + sku + '!', true);
        helper.push(pushObject);
    },

    pushCancelYourOrderInteraction (orderId) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '65',
            'eventname': 'cancel_your_order',
            'action': 'click',
            'order': orderId
        };

        helper.log('Pushing cancel your order interaction!', true);
        helper.push(pushObject);
    },

    pushCancelYourOrderInteractionAction (orderId, action) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '66',
            'eventname': 'cancel_your_order',
            'action': action,
            'label': orderId
        };

        helper.log('Pushing cancel your order interaction!', true);
        helper.push(pushObject);
    },

    // Made In
    pushReadTheWholeInterview () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '80',
            'eventname': 'made_in',
            'action': 'read_the_whole_interview'
        };

        helper.log('Pushing read the whole interview interaction!', true);
        helper.push(pushObject);
    },

    pushMadeInPlantInteraction (plant) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '81',
            'eventname': 'made_in',
            'action': 'click',
            'text': plant
        };

        helper.log('Pushing read the made in plant interaction for ' + plant + ' !', true);
        helper.push(pushObject);
    },

    pushSmartGift (sku, name) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '98',
            'eventname': 'send_product_with_smartgift',
            'product_id': sku.replace(/\s+/g, '_')
        };

        helper.log('Pushing smartgift event!', true);
        helper.push(pushObject);
    },

    pushSmartGiftBasketInteraction106 (action, skus, quantity) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '106',
            'eventname': 'product_smartgift',
            'action': action,
            'type': quantity,
            'product_id': skus
        };

        helper.log('Pushing smartgift basket button interaction event! ', true);
        helper.push(pushObject);
    },

    pushSmartGiftBasketInteraction107 (productName, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '107',
            'eventname': 'product_smartgift',
            'action': 'remove',
            'product_id': sku
        };

        helper.log('Pushing smartgift basket remove product interaction event!', true);
        helper.push(pushObject);
    },

    pushSmartGiftBasketInteraction108 (location) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '108',
            'eventname': 'product_smartgift',
            'action': 'open_banner'
        };

        helper.log('Pushing smartgift basket mini icon interaction event!', true);
        helper.push(pushObject);
    },

    pushSmartGiftMoreInfo () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '109',
            'eventname': 'product_smartgift',
            'action': 'more_info'
        };

        helper.log('Pushing smartgift more info interaction event!', true);
        helper.push(pushObject);
    },

    pushBubbleClickInteraction (pageType) {
        if (!pageType) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '44',
            'eventname': 'popup_help',
            'action': 'click'
        };

        let position = helper.mapPosition();
        if (position) {
            pushObject.position = position;
        }

        helper.log('Pushing bubble chat interaction!', true);
        helper.push(pushObject);
    },

    pushESWInteraction (selection, location) {
        if (!selection || !location) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '45',
            'eventname': 'popup_help',
            'action': selection
        };

        let position = helper.mapPosition();
        if (position) {
            pushObject.position = position;
        }

        helper.log('Pushing esw interaction!', true);
        helper.push(pushObject);
    },

    pushEcoChoiceClick (location, user) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '74',
            'eventname': 'ecological_choice_more_info',
            'position': location,
            'type': user || 'not_available'
        };

        helper.log('Pushing eco choice actions: ', true);
        helper.push(pushObject);
    },

    pushTrackYourOrder (transactionID) {
        if (!transactionID) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '111',
            'eventname': 'track_your_order',
            'order': transactionID
        };

        helper.log('Pushing track your order interaction!', true);
        helper.push(pushObject);
    },

    pushPersonalAreaNavigationOrderSection (cta) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '112',
            'eventname': 'my_orders_select',
            'text': cta
        };
        helper.push(pushObject);
    },
    pushMenuItemsOnTopLeftInteraction (itemClicked) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '144',
            'eventname': 'main_menu',
            'menu_items': itemClicked
        };

        helper.log('Pushing menu item on the top left interaction for ' + itemClicked + '!', true);
        helper.push(pushObject);
    },
    pushPrivacyPolicyPopUP (pageType, privacyNews, privacyCustomNews) {
        if (!pageType) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '149',
            'eventname': 'privacy_consents',
            'position': 'pop_up',
            'action': pageType,
            'privacy_news': privacyNews,
            'privacy_custom_news': privacyCustomNews
        };

        helper.log('Pushing pushPrivacyPolicyPopUP!', true);
        helper.push(pushObject);
    },
    pushStartTheQuiz (quizButton, pageType) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '155',
            'eventname': 'find_your_bra_quiz',
            'step': 'step1',
            'area': quizButton,
            'position': pageType
        };

        helper.log('Pushing pushStartTheQuiz!', true);
        helper.push(pushObject);
    },
    pushOurAdvice (adviceType) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '156',
            'eventname': 'bra_our_advice',
            'label': adviceType
        };

        helper.log('Pushing pushOurAdvice!', true);
        helper.push(pushObject);
    },
    pushReasonForBraQuiz (answerChoosen) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '157',
            'eventname': 'find_your_bra_quiz',
            'step': 'step2-what_brings_you_here_today',
            'area': answerChoosen
        };

        helper.log('Pushing pushReasonForBraQuiz!', true);
        helper.push(pushObject);
    },
    pushSizeForBraQuiz (sizeType, answerChoosen) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '158',
            'eventname': 'find_your_bra_quiz',
            'step': 'step3-what_is_your_current_bra_size',
            'area': sizeType + '_' + answerChoosen
        };

        helper.log('Pushing pushSizeForBraQuiz!', true);
        helper.push(pushObject);
    },
    pushUnderbustChangeForBraQuiz (answerChoosen) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '159',
            'eventname': 'find_your_bra_quiz',
            'step': 'step4-have_you_ever_encountered_adjustment_problems_of_the_bras',
            'area': answerChoosen
        };

        helper.log('Pushing pushUnderbustChangeForBraQuiz!', true);
        helper.push(pushObject);
    },
    pushCupChangeForBraQuiz (answerChoosen) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '160',
            'eventname': 'find_your_bra_quiz',
            'step': 'step5_what_style_are_you_looking_for_your_bra',
            'area': answerChoosen
        };

        helper.log('Pushing pushUnderbustChangeForBraQuiz!', true);
        helper.push(pushObject);
    },
    pushStyleForBraQuiz (answerChoosen) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '161',
            'eventname': 'find_your_bra_quiz',
            'step': 'step6-what_are_you_looking_for_your_bra',
            'area': answerChoosen
        };

        helper.log('Pushing pushStyleForBraQuiz!', true);
        helper.push(pushObject);
    },
    pushEffectForBraQuiz (answerChoosen) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '162',
            'eventname': 'find_your_bra_quiz',
            'step': 'step7-what_effect_would_you_like_to_give_to_your_decollete',
            'area': answerChoosen
        };

        helper.log('Pushing pushEffectForBraQuiz!', true);
        helper.push(pushObject);
    },
    pushTypeForBraQuiz (answerChoosen) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '163',
            'eventname': 'find_your_bra_quiz',
            'step': 'step8-what_type_of_support_are_you_looking_for',
            'area': answerChoosen
        };

        helper.log('Pushing pushTypeForBraQuiz!', true);
        helper.push(pushObject);
    },
    pushFabricForBraQuiz (answerChoosen) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '164',
            'eventname': 'find_your_bra_quiz',
            'step': 'step9-which_fabric_do_you_prefer',
            'area': answerChoosen
        };

        helper.log('Pushing pushFabricForBraQuiz!', true);
        helper.push(pushObject);
    },
    pushThankYouForBraQuiz (answerChoosen) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '165',
            'eventname': 'find_your_bra_quiz',
            'step': 'quiz_complete',
            'area': answerChoosen
        };

        helper.log('Pushing pushThankYouForBraQuiz!', true);
        helper.push(pushObject);
    },
    // 6.137 Cookie Banner
    pushCookieBanner (ctaClicked) {
        if (!ctaClicked) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '166',
            'eventname': 'cookie_banner',
            'label': ctaClicked
        };

        helper.log('Pushing cookie banner cta ' + ctaClicked, true);
        helper.push(pushObject);
    }
};
